import { makeAutoObservable } from "mobx";
import { BaseSearchObject } from "app/common/Model/SearchObject";
import { toast } from "react-toastify";
import {
  getGlobalPropertyById,
  markDeleteGlobalProperty,
  pagingExtGlobalProperty,
  saveOrUpdateGlobalProperty,
} from "app/services/GlobalPropertyService";

const DEFAULT_VALUES = {
  globalPropertyDepartments: [],
};
export default class GlobalPropotiesStore {
  pageGlobalPropoties = null;
  searchGlobalPropoties = new BaseSearchObject();
  selectedGlobalPropoties = {
    ...DEFAULT_VALUES,
  };
  openFormCreateOrEdit = false;
  openConfirmDelete = false;
  selectedRowProperty = null
  constructor() {
    makeAutoObservable(this);
  }

  setSelectedRowProperty = (row) => {
    this.selectedRowProperty = row;
  };

  saveOrUpdateGlobalProperty = (obj) => {
    let { globalPropertyDepartments, ...ortherData } = obj;
    globalPropertyDepartments = globalPropertyDepartments?.map((el) => ({
      department: el,
    }));
    saveOrUpdateGlobalProperty({ globalPropertyDepartments, ...ortherData })
      .then(() => {
        toast.success("Lưu dữ liệu thành công", "Thông báo");
        this.handleClosePopup();
        this.pagingGlobalPropoties();
      })
      .catch((error) => {
        toast.error("Lưu dữ liệu thất bại", "Thông báo");
      });
  };

  // saveGlobalPropoties = async (obj) => {
  //     saveGlobalPropoties(obj)
  //         .then(({ data }) => {
  //             toast.success("Lưu dữ liệu thành công", "Thông báo");
  //             this.handleClosePopup();
  //             this.pagingGlobalPropoties();
  //         })
  //         .catch(error => {
  //             toast.error("Lưu dữ liệu thất bại", "Thông báo");
  //         })
  // }

  // updateGlobalPropoties = async (obj) => {
  //     return await updateGlobalPropoties(obj)
  //         .then(({ data }) => {
  //             toast.success("Chỉnh sửa dữ liệu thành công", "Thông báo");
  //         })
  //         .catch(error => {
  //             toast.error("Chỉnh sửa dữ liệu thất bại", "Thông báo");
  //         })
  // }

  pagingGlobalPropoties = async () => {
    let { departmentIds, ...ortherData } = this.searchGlobalPropoties;
    if (departmentIds) {
      ortherData.departmentIds = departmentIds?.map((el) => el?.id);
    }
    return await pagingExtGlobalProperty(ortherData)
      .then(({ data }) => {
        this.pageGlobalPropoties = data;
        return { data };
      })
      .catch((error) => {
        toast.error("Lấy dữ liệu có lỗi", "Thông báo");
      });
  };

  handleOpenFormCreateOrEdit = (id) => {
    if (id) {
      getGlobalPropertyById(id).then(({ data }) => {
        if (data?.globalPropertyDepartments) {
          data.globalPropertyDepartments = data?.globalPropertyDepartments?.map(
            (el) => el?.department
          );
        }
        this.selectedGlobalPropoties = {
          ...data,
          globalPropertyDepartments: data?.globalPropertyDepartments
            ? data?.globalPropertyDepartments
            : [],
        } || {
          ...DEFAULT_VALUES,
        };
        this.openFormCreateOrEdit = true;
      });
    } else {
      this.selectedGlobalPropoties = {
        ...DEFAULT_VALUES,
      };
      this.openFormCreateOrEdit = true;
    }
  };

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
  };

  handleChangeFormSearch = (searchGlobalPropoties) => {
    this.searchGlobalPropoties = {
      ...this.searchGlobalPropoties,
      ...searchGlobalPropoties,
    };
    this.pagingGlobalPropoties();
  };

  handleDelete = (obj) => {
    this.selectedGlobalPropoties = obj;
    this.openConfirmDelete = true;
  };

  handleConfirmDelete = async () => {
    return await markDeleteGlobalProperty(
      this.selectedGlobalPropoties?.property
    )
      .then(() => {
        this.searchGlobalPropoties.pageIndex = 1;
        toast.success("Xóa bản ghi thành công!");
        this.handleClosePopup();
        this.pagingGlobalPropoties();
        this.recentlyUpdated = true;
      })
      .catch(() => {
        toast.error("Xóa bản ghi có lỗi", "Thông báo");
      });
  };

  resetStore = () => {
    this.pageGlobalPropoties = null;
    this.searchGlobalPropoties = new BaseSearchObject();
    this.selectedGlobalPropoties = {
      ...DEFAULT_VALUES,
    };
    this.openFormCreateOrEdit = false;
    this.openConfirmDelete = false;
    this.selectedRowProperty = null;
  };
}
